import { Controller } from 'stimulus';
import Swiper from 'swiper';
import { Mousewheel, Navigation } from 'swiper/modules';

class Timeline extends Controller {
  connect() {
    this.createDraggable();
  }

  createDraggable() {
    Swiper.use([Navigation, Mousewheel]);

    this.slider = new Swiper(this.sliderTarget, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      freeMode: true,
      initialSlide: this.data.get('initial-slide'),
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

Timeline.targets = [
  'slider',
];

export default Timeline;
